import React from "react";
import { Button, Col, Typography } from "antd";

import CustomRow from "../../shared/costum-row/costum-row";
import CustomImage from "../../shared/custom-image/custom-image";
import CustomButton from "../../shared/custom-button/custom-button";

import "./styles.scss";
import { BUTTON_VARIANTS } from "../../constants/styles";

const { Title, Text } = Typography;

const TeaserTeam = () => {
  return (
    <div className="TeaserTeam">
      <CustomImage src="../team.jpg" className="TeaserTeam-image" />
      <div className="TeaserTeam-content">
        <div className="TeaserTeam-content-title">
          <Title className="mb-3xs">Meet the team</Title>
        </div>
        <div className="TeaserTeam-content-description">
          <Text>
          From friends to founders, we turned our mutual passion for coding into a software company.
           Get familiar with the core team members that assembled to start and shape Soloop.
          </Text>
        </div>
        {/* <div className="TeaserTeam-content-button">
          <CustomButton btnVariant={BUTTON_VARIANTS.SECONDARY}>
            Button
          </CustomButton>
        </div> */}
      </div>
    </div>
  );
};

export default TeaserTeam;
